//@ts-check
import { InstanceTree, NODE_TYPE } from '../../wgs/scene/InstanceTree';
import { InstanceTreeAccess } from '../../wgs/scene/InstanceTreeStorage';
import { RcsPropDbLoader, prop } from './RcsPropDbLoader.js';

/** @typedef {import('./RcsPropDbLoader').RcsPropertyData} RcsPropertyData */
/** @typedef {import('../../wgs/scene/InstanceTreeStorage').InstanceTreeStorage} InstanceTreeStorage */

/**
 * Property database loader for RCS point clouds in simple mode.
 * Creates a minimal property database with a single node (dbId 1) named "Point Cloud".
 *
 * @class
 * @extends RcsPropDbLoader
 */
export class RcsSimplePropDbLoader extends RcsPropDbLoader {

  /**
   * @param {InstanceTreeStorage} storage
   * @returns {InstanceTree}
   * @protected
   */
  _buildInstanceTree(storage) {
    // Simple mode: Single node with all fragments
    this.rootDbId = 1;
    const allFragIds = [];
    for (let fragId = 0; fragId < this.numFragments; fragId++) {
      allFragIds.push(fragId);
    }

    storage.setNode(
      1, // dbId
      0, // parentDbId (0 = root)
      "Point Cloud", // name
      NODE_TYPE.NODE_TYPE_MODEL, // flags
      [], // childrenIds
      allFragIds, // fragIds (all fragments)
      0 // level
    );

    storage.flatten();
    const nodeAccess = new InstanceTreeAccess(storage, 1, null);
    return new InstanceTree(nodeAccess, 1, 1);
  }

  /**
   * @param {number} dbId
   * @returns {RcsPropertyData|null}
   * @protected
   */
  _createPropertyData(dbId) {
    if (dbId === 1) {
      return {
        dbId: 1,
        name: "Point Cloud",
        externalId: "PointCloud_Root",
        properties: [
        prop("Name", "Point Cloud", "__name__"),
        prop("Type", "RCS Point Cloud")]

      };
    }
    return null;
  }
}